import { AxiosResponse } from "axios";
import ApiConstants from "../../../../core/constants/api_constants";
import { request } from "../../../../core/network/axiosInstance";

export class ThemeApiService {
  private readonly themeBaseUrl: string;

  constructor() {
    this.themeBaseUrl = ApiConstants().theme;
  }

  async getThemeByCompanyId(id: string): Promise<AxiosResponse> {
    const response = await request({
      method: "GET",
      url: `${this.themeBaseUrl}company/${id}`,
      requiresToken: true,
    });
    return response;
  }

  async getThemeById(id: string): Promise<AxiosResponse> {
    const response = await request({
      method: "GET",
      url: `${this.themeBaseUrl}${id}`,
      requiresToken: true,
    });
    return response;
  }
}
